// extracted by mini-css-extract-plugin
export default {"quickNav":"Console_quickNav__CT2xY"};